"use strict";

export default (isDevMode, flex = window.flex) => {

    const { getUrlParam, isIE } = flex;

    let {
        sessionStorage = {
            getItem: () => {
                return false;
            },
            setItem: () => {
            }
        }
    } = window;

    const STORAGE_KEY = '9ebb7162-6544-4a85-a43f-11603faa3faa';
    const DEFAULT_ACTION = isDevMode ? 'enable' : 'disable';

    const OPERATIONS = {
        enable: () => {
            sessionStorage.setItem(STORAGE_KEY, true);
            // cant do this, causes double post on sso
            //window.location.reload();
        },
        disable: () => {
            nukeTheThings();
            sessionStorage.setItem(STORAGE_KEY, false);
        }
    };

    function nukeTheThings() {
        let consoleMethodNames = [];
        // I hate you IE
        for (let key in window.console) {
            consoleMethodNames.push(key);
        }
        consoleMethodNames.forEach(methodName => {
            window.console[methodName] = () => {};;
        });
    }

    function bootStrap() {
        let state = getUrlParam('__console');
        if (!state) {
            state = sessionStorage.getItem(STORAGE_KEY);
        }

        if (state === 'false') {
            OPERATIONS.disable();
        } else if (state === 'true') {
            sessionStorage.setItem(STORAGE_KEY, true);
        } else if (DEFAULT_ACTION in OPERATIONS) {
            OPERATIONS[DEFAULT_ACTION]();
        }

        if(isIE()) {
            let iHateIE = setInterval(() => {
                let shouldBeDisabled = sessionStorage.getItem(STORAGE_KEY) === 'false',
                    needsToBeNuked = shouldBeDisabled && window.console && window.console.log && window.console.log.toString().length > 20;

                if (needsToBeNuked) {
                    nukeTheThings();
                    clearInterval(iHateIE);
                }
            }, 1000)
        }
    }

    bootStrap();

    return OPERATIONS;
};